import { ConvertGramsToKiloGrams, ConvertKiloGramsToGrams } from '@/utils/converters';

function transformItem2Dto(item) {
  const dto = {
    ...item,
    id: item.parcelTypeID,
    maximumWeightInG: ConvertKiloGramsToGrams(item.maximumWeightInKg),
    maximumLengthInMm: item.maximumLengthInM * 1000
  };

  delete dto.maximumWeightInKg;
  delete dto.maximumLengthInM;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.parcelTypeID,
    maximumWeightInKg: ConvertGramsToKiloGrams(dto.maximumWeightInG),
    maximumLengthInM: dto.maximumLengthInMm / 1000
  };
  delete item.maximumWeightInG;
  delete item.maximumLengthInMm;
  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };
